<router-outlet />
<!-- CHANGELOG MODAL -->
<div class="changelog-overlay" *ngIf="showChangelog" (click)="closeChangelog()">
  <div class="changelog-modal" (click)="$event.stopPropagation()">
    <div class="changelog-header">
      <div>
        <p class="changelog-eyebrow">{{ "changelog_modal.eyebrow" | translate }}</p>
        <h2 class="changelog-title">{{ "changelog_modal.version" | translate }} {{ appVersion }}</h2>
      </div>
      <button class="changelog-close" (click)="closeChangelog()">✕</button>
    </div>

    <div class="changelog-body">
      <div
        *ngFor="let section of latestChangelog.sections"
        class="changelog-section"
      >
        <span class="changelog-tag" [class]="section.tag">{{
          section.label
        }}</span>
        <ul>
          <li *ngFor="let item of section.items">{{ item }}</li>
        </ul>
      </div>
    </div>

    <div class="changelog-footer">
      <a
        routerLink="/novita"
        class="changelog-view-all"
        (click)="closeChangelog()"
      >
        {{ "changelog_modal.view_all" | translate }}
      </a>
      <button class="btn-gold" (click)="closeChangelog()">
        {{ "changelog_modal.cta" | translate }}
      </button>
    </div>
  </div>
</div>
